var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.91016 14.5586L1.28516 11.9336C1.01172 11.6875 1.01172 11.2773 1.28516 11.0039C1.53125 10.7578 1.94141 10.7578 2.21484 11.0039L3.71875 12.5352V8.40625H0.65625C0.273438 8.40625 0 8.13281 0 7.75C0 7.39453 0.273438 7.09375 0.65625 7.09375H3.71875H5.03125H10.7188V2.99219L9.21484 4.49609C8.94141 4.76953 8.53125 4.76953 8.28516 4.49609C8.01172 4.25 8.01172 3.83984 8.28516 3.56641L10.9102 0.941406C11.1562 0.695312 11.5664 0.695312 11.8398 0.941406L14.4375 3.56641C14.7109 3.83984 14.7109 4.25 14.4375 4.49609C14.1914 4.76953 13.7812 4.76953 13.5352 4.49609L12.0312 2.99219V7.09375H15.0938C15.4492 7.09375 15.75 7.39453 15.75 7.75C15.75 8.13281 15.4492 8.40625 15.0938 8.40625H5.03125V12.5352L6.53516 11.0312C6.78125 10.7578 7.19141 10.7578 7.4375 11.0312C7.71094 11.2773 7.71094 11.6875 7.4375 11.9336L4.8125 14.5586C4.56641 14.832 4.15625 14.832 3.91016 14.5586ZM3.71875 6V2.28125C3.71875 1.92578 3.99219 1.625 4.375 1.625C4.73047 1.625 5.03125 1.92578 5.03125 2.28125V6H3.71875ZM12.0312 9.5V13.2188C12.0312 13.6016 11.7305 13.875 11.375 13.875C10.9922 13.875 10.7188 13.6016 10.7188 13.2188V9.5H12.0312Z",
    fill: "#354A5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReorder);
export default __webpack_public_path__ + "static/media/icon_reorder.af8f9169c275d39941c17c45949ea563.svg";
export { ForwardRef as ReactComponent };